import {Fill, Stroke, Style, Text} from "ol/style";

export const inventoryZonesStyle = () => {
    return [
        new Style({
            stroke: new Stroke({
                color: 'rgb(0, 200, 255)',
            }),
        })
    ];
}

export const showInventoryZonesStyle = () => {
    return [
        new Style({
            stroke: new Stroke({
                color: 'rgba(255,174,0, 0.6)',
            }),
        })
    ]
}

const getHeatmapColor = (value) => {
    return `rgba(255, ${255 - value * 255}, 0, 0.3)`;
}

export const inventoryZonesHeatmapStyle = (feature) => {
    let data = feature.get('feature-data')

    if(data.data.length === 0) {
        return new Style();
    }

    return [
        new Style({
            fill: new Fill({
                color: getHeatmapColor(data.data.length / data.quantity_max)
            }),
            text: new Text({
                textAlign: 'center',
                textBaseline: 'middle',
                text: data.data.length.toString(),
                fill: new Fill({color: 'white'}),
                stroke: new Stroke({color: 'black', width: 2}),
                placement: 'point',
                font: '14px sans-serif',
                overflow: 'overflow',
            }),
        })
    ]
}
